//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionText, Typography } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import FormattedMessage from '@i18n/components/FormattedMessage'

import translations from './Info.translations'

export default {
  components: {
    ActionText,
    Typography,
    FormattedMessage,
  },
  props: {
    infoOptions: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,

    displayName() {
      return (
        this.infoOptions.firstName ||
        (this.infoOptions.nbClientOrders !== undefined &&
          this.infoOptions.nbClientOrders !== null)
      )
    },

    productLink() {
      if (
        isEmpty(this.infoOptions.link?.params?.slug) ||
        isEmpty(this.infoOptions.link?.params?.slugV2)
      ) {
        return null
      }

      return this.infoOptions.link
    },
  },
}
